import { connect, getIn } from 'formik';
import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

import { MINIMUM_PAYMENTS_COUNT } from 'hb-react/shared/apps/Donations/constants/payments';
import {
  Radio,
  Number,
} from 'hb-react/shared/components/formik/components/inputs';
import {
  numberWithTwoDecimals,
  numberWithCurrency,
} from 'hb-react/shared/utils/formatNumber';

const Lifelong = ({ formik, enabled, currency }) => {
  if (!enabled) {
    return null;
  }

  const lifelongEnabled =
    getIn(formik.values, 'donation_order[lifelong_payment_enabled]') === 'true';
  const amount = getIn(formik.values, 'donation_order[amount]');
  const numberOfPayments = getIn(
    formik.values,
    'donation_order[recurring_payments_left]',
  );

  return (
    <>
      <Radio
        style={{ border: 'solid 1px blue' }}
        name="donation_order[lifelong_payment_enabled]"
        type="toggle"
        validate={{
          required: true,
        }}
        inputs={[
          {
            value: 'true',
            label: __('Until I cancel'),
          },
          {
            value: 'false',
            label: __('For a limited time'),
          },
        ]}
        mb={0}
      />
      {!lifelongEnabled && (
        <div className="flex flex-end push--top soft--left bordered--left border-color--mediumgray border-width--2">
          <Number
            name="donation_order[recurring_payments_left]"
            label={__('Number of payments')}
            validate={{
              required: true,
              minimum: MINIMUM_PAYMENTS_COUNT,
            }}
            wrapperProps={{
              width: 250,
              mr: 2,
              mb: 0,
            }}
          />

          <div style={{ marginBottom: '2px' }}>
            <Box font="body-dove-italic" mb="3px">
              {__('%{amount} by payment').i__({
                amount: numberWithCurrency(amount, currency),
              })}
            </Box>
            <Box font="body-semibold-asphalt">
              {__('%{fullAmount} in total').i__({
                fullAmount: numberWithCurrency(
                  numberWithTwoDecimals(amount) * numberOfPayments,
                  currency,
                ),
              })}
            </Box>
          </div>
        </div>
      )}
    </>
  );
};

Lifelong.propTypes = {
  currency: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
};

export default connect(Lifelong);
